import styled from 'styled-components';
import { smRegular } from '@hud/web-components/theme/typography';

export const Description = styled.p`
  margin-top: -16px;
  ${smRegular}

  a {
    color: #0ffbe4;
    text-decoration: none;
  }
`;

export const HeaderDescription = styled(Description)`
  margin-bottom: -24px;
  margin-top: -8px;
`;
